function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { isLocalStorageAvailable } from "@kaggle/core";
import { getApp, initializeApp, setLogLevel } from "firebase/app";
import { getAuth, signInAnonymously, signInWithCustomToken } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { featureFlags } from "../featureFlags";
var apps = new Map();
var daysSinceUnixMillis = function(then) {
    var now = new Date();
    return (now.getTime() - then) / (1000 * 3600 * 24);
};
export var ensureClientInitialized = function(appName, firebaseConfig, onFirebaseConnectionError) {
    if (onFirebaseConnectionError) {
        errorDispatcher.addListener(appName, onFirebaseConnectionError);
    }
    if (!apps.has(appName)) {
        apps.set(appName, initializeClient(appName, firebaseConfig));
    }
    return apps.get(appName);
};
var initializeClient = function() {
    var _ref = _asyncToGenerator(function(appName, firebaseConfig) {
        var useFirestoreProxy, app, ref, ref1, ref2, ref3, ref4, ref5, auth, failover, _tmp, cli, timeout, e;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    useFirestoreProxy = featureFlags.kernelsFirebaseProxy || isLocalStorageAvailable() && !!localStorage.useProxy && daysSinceUnixMillis(localStorage.useProxyUpdateTime) < 1; // expire proxy failover after 1 day
                    try {
                        // Throws an exception if the app hasn't been initialized yet.
                        app = getApp(appName);
                    } catch (e1) {
                        ;
                        app = initializeApp({
                            apiKey: (ref = firebaseConfig.options) === null || ref === void 0 ? void 0 : ref.apiKey,
                            appId: (ref1 = firebaseConfig.options) === null || ref1 === void 0 ? void 0 : ref1.appId,
                            authDomain: (ref2 = firebaseConfig.options) === null || ref2 === void 0 ? void 0 : ref2.authDomain,
                            messagingSenderId: (ref3 = firebaseConfig.options) === null || ref3 === void 0 ? void 0 : ref3.messagingSenderId,
                            projectId: (ref4 = firebaseConfig.options) === null || ref4 === void 0 ? void 0 : ref4.projectId,
                            storageBucket: (ref5 = firebaseConfig.options) === null || ref5 === void 0 ? void 0 : ref5.storageBucket
                        }, appName);
                    }
                    if (featureFlags.kernelsFirestoreDebugLogging) {
                        setLogLevel("debug");
                    }
                    auth = getAuth(app);
                    if (useFirestoreProxy && firebaseConfig.proxyDomain) {
                        // Proxy auth-related calls.
                        auth.config.apiHost = firebaseConfig.proxyDomain; // Proxy calls to identitytoolkit.googleapis.com
                        auth.config.tokenApiHost = firebaseConfig.proxyDomain; // Proxy calls to securetoken.googleapis.com
                        auth.config.authDomain = firebaseConfig.proxyDomain; // Proxy calls to <database>.firebaseapp.com (database is inferred from api key)
                        initializeFirestore(app, {
                            host: firebaseConfig.proxyDomain,
                            experimentalForceLongPolling: featureFlags.kernelsFirebaseLongPolling
                        });
                    }
                    failover = function(e) {
                        if (!useFirestoreProxy) {
                            if (isLocalStorageAvailable()) {
                                // Try to reload the page with proxying turned on:
                                localStorage.useProxy = true;
                                var now = new Date();
                                localStorage.useProxyUpdateTime = now.getTime();
                                location.reload();
                                return;
                            }
                            errorDispatcher.dispatch(appName, "Failed to connect to Firestore. " + (e !== null && e !== void 0 ? e : ""));
                            return;
                        }
                        errorDispatcher.dispatch(appName, "Failed to connect to Firestore via Jupyter. " + (e !== null && e !== void 0 ? e : ""));
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    if (!(firebaseConfig.authToken && firebaseConfig.authToken.length > 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        signInWithCustomToken(auth, firebaseConfig.authToken)
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        signInAnonymously(auth)
                    ];
                case 4:
                    _tmp = _state.sent();
                    _state.label = 5;
                case 5:
                    _tmp;
                    cli = getFirestore(app);
                    timeout = useFirestoreProxy ? 60000 : 10000;
                    window.setTimeout(function() {
                        var ref, ref1, ref2;
                        var status = (ref = cli._firestoreClient) === null || ref === void 0 ? void 0 : (ref1 = ref.onlineComponents) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.syncEngine) === null || ref2 === void 0 ? void 0 : ref2.onlineState;
                        if (status !== "Online") {
                            failover();
                        }
                    }, timeout);
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    if (e.code && e.code === "auth/network-request-failed") {
                        failover(e);
                    } else {
                        errorDispatcher.dispatch(appName, "Failed to connect to Firestore: " + e);
                    }
                    throw e;
                case 7:
                    return [
                        2,
                        app
                    ];
            }
        });
    });
    return function initializeClient(appName, firebaseConfig) {
        return _ref.apply(this, arguments);
    };
}();
var FirebaseConnectionErrorDispatcher = function FirebaseConnectionErrorDispatcher() {
    "use strict";
    var _this = this;
    _classCallCheck(this, FirebaseConnectionErrorDispatcher);
    this.listeners = new Map();
    this.addListener = function(appName, listener) {
        var listenersForApp = _this.listeners.get(appName);
        if (!listenersForApp) {
            listenersForApp = new Array();
            _this.listeners.set(appName, listenersForApp);
        }
        listenersForApp.push(listener);
    };
    this.dispatch = function(appName, errorMsg) {
        var listenersForApp = _this.listeners.get(appName);
        if (listenersForApp) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = listenersForApp[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var listener = _step.value;
                    listener(errorMsg);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
};
var errorDispatcher = new FirebaseConnectionErrorDispatcher();
